export const inlineTypes = [
  { style: 'BOLD', iconName: 'bold' },
  { style: 'ITALIC', iconName: 'italic' },
  { style: 'STRIKETHROUGH', iconName: 'strikethrough' },
];


// WEBPACK FOOTER //
// ./src/component/TextEditor/inlineTypes.js